@if (hasErrors || hasWarnings) {
  <div class="cart-summary-notifications">
    @if (hasErrors) {
      <ds-alert
        alert_type="error"
        [alert_message]="errorMessage"
        alert_action_type="none">
      </ds-alert>
    }
    @if (hasWarnings) {
      <ds-alert
        alert_type="warning"
        [alert_message]="warningMessage"
        alert_action_type="none">
      </ds-alert>
    }
  </div>
}
